module.exports = __webpack_public_path__ + "static/screen-workout-logging.30561e07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stronglist/screen-workout-logging.jpg
// module id = 386
// module chunks = 212420072151734